module.exports = __webpack_public_path__ + "assets/img/Affiches_014.9b5056c3.jpg";